module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('WeexThemeView', {
    key: _vm.disabled + _vm._theme + ''
  }, [(_vm.pattern === 'plain_text') ? _c('text', {
    class: ['btn-text', _vm.isHighlight && !_vm.disabled && _vm.pattern === 'text' && !_vm._isColmo && ("dof-text-highlight-" + _vm.type)],
    style: _vm.mrTextStyle,
    attrs: {
      "ariaLabel": _vm.text ? _vm.text + '。按钮。' : ''
    },
    on: {
      "click": _vm.onTextClicked
    }
  }, [_vm._v(_vm._s(_vm.loading && _vm.size == 'small' ? '' : _vm.text))]) : _c('div', {
    class: ['dof-btn', _vm.isHighlight && !_vm.disabled && !_vm._isColmo && ("dof-btn-highlight-" + _vm.type + "-" + _vm.pattern)],
    style: _vm.mrBtnStyle,
    attrs: {
      "accessible": true,
      "ariaLabel": _vm.text ? _vm.text + '。按钮。' : ''
    },
    on: {
      "click": _vm.onClicked
    }
  }, [(_vm.loading) ? _c('dof-spinner', {
    staticClass: ["loading-image"],
    attrs: {
      "type": _vm.loadingGif
    }
  }) : _vm._e(), _vm._t("default", [_c('text', {
    class: ['btn-text', _vm.isHighlight && !_vm.disabled && _vm.pattern === 'text' && ("dof-text-highlight-" + _vm.type)],
    style: _vm.mrTextStyle,
    attrs: {
      "ariaLabel": _vm.text ? _vm.text + '。按钮。' : ''
    },
    on: {
      "click": _vm.onTextClicked
    }
  }, [_vm._v(_vm._s(_vm.loading && _vm.size == 'small' ? '' : _vm.text))])]), (_vm._isColmo && !_vm.disabled && !_vm.loading) ? _c('div', {
    staticClass: ["mask"],
    on: {
      "click": _vm.onClicked
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-e24c8c6a!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-button/index.vue
// module id = 673
// module chunks = 0 1